import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Cards from 'react-credit-cards';

import './index.css'
import { AiOutlineStar } from 'react-icons/ai'
import { BsTrash } from 'react-icons/bs'

export default function CreditCardForm({ creditCard }) {
  const [number, setNumber] = useState(creditCard.number)
  const [name, setName] = useState(creditCard.name)
  const [expiry, setExpiry] = useState(creditCard.expiry)
  const [cvc, setCvc] = useState(creditCard.cvc)
  const focus = '';

  return (
    <div className="CreditCardForm">
      <Row>
        <Col md={6} className="creditCard-container">
          <div >
            <span className={(creditCard.main ? 'main-badge' : 'display-hidden')}>
              Cartão Principal
            </span>
            <div className={(creditCard.main ? 'main-credit-card' : '')}>
              <Cards
                cvc={cvc}
                expiry={expiry}
                focused={focus}
                name={name}
                number={number}
              />
            </div>
          </div>
          {creditCard.main ?
            <>
            </>
            :
            <Button variant="warning" className="button-margin-top">
              Tornar Principal
              <AiOutlineStar size='.7em' style={{ marginLeft: '1rem' }} />
            </Button>
          }
          <Button variant="secondary" className="button-margin-top">
            Excluir Cartão
              <BsTrash size='.7em' style={{ marginLeft: '1rem' }} />
          </Button>
        </Col>
        <Col md={6}>
          <Form method="POST" onSubmit={() => false}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Número do cartão</Form.Label>
              <Form.Control type="text" name="number" value={number} onChange={(e) => setNumber(e.target.value)}
              // ref={register} onChange={(e) => setNumber(e.target.value)} onFocus={handleFocus} 
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Nome no cartão</Form.Label>
              <Form.Control type="text" name="name" value={name} onChange={(e) => setName(e.target.value)}
              // ref={register} onChange={(e) => setName(e.target.value)} onFocus={handleFocus} 
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group controlId="formBasicPassword">
                  <Form.Label>Vencimento</Form.Label>
                  <Form.Control type="text" name="expiry" value={expiry} onChange={(e) => setExpiry(e.target.value)}
                  // ref={register} onChange={(e) => setExpiry(e.target.value)} onFocus={handleFocus} 
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="formBasicPassword">
                  <Form.Label>Código de segurança</Form.Label>
                  <Form.Control type="text" name="cvc" value={cvc} onChange={(e) => setCvc(e.target.value)}
                  // ref={register} onChange={(e) => setCvc(e.target.value)} onFocus={handleFocus} 
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button variant="primary" type="submit">
              Salvar
            </Button>
          </Form>
        </Col>
      </Row>
    </div >
  )
}
